import { makeStyles, Theme, createStyles } from "@material-ui/core";
import colors from "../../common/styles/colors";
import fonts from "../../common/styles/fonts";
import palette from "../../common/styles/palette";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerItem: {
      backgroundColor: colors.white,
      ...theme.typography.body2,
      padding: theme.spacing(4),
      textAlign: "left",
      color: theme.palette.text.secondary,
      borderRadius: palette.radius,
    },
    containerTabMenu: {
      width: "100%",
      backgroundColor: colors.white,
      border: "1px solid " + colors.grayDLight,
      borderRadius: palette.radius,
      boxShadow: palette.shadowSm,
    },
    container: {
      marginTop: 40,
    },
    containerFiles: {
      marginTop: 40,
      display: "flex",
      alignItems: "center",
    },
    containerCards: {
      display: "flex",
      flexWrap: "wrap",
    },
    containerCard: {
      width: 289,
      marginRight: 15,
      marginBottom: 15,
      padding: 20,
      cursor: "pointer",
    },
    breadCrumbCard: {
      textTransform: "uppercase",
      color: colors.purpleMedium,
    },
    titleCard: {
      color: colors.blueDark,
      textAlign: "left",
    },
    titleCard_2: {
      color: colors.blueDark,
      marginTop: "10px !important",
      marginBottom: "15px !important",
    },
    dividerCard: {
      borderColor: colors.grayDLight,
    },
    dividerStation: {
      borderColor: colors.grayDLight,
    },
    dateEvent: {
      color: colors.blackMedium,
      marginTop: "15px !important",
      marginBottom: "10px !important",
    },
    statusLabelEventNext: {
      color: colors.blueMedium,
      fontWeight: 700,
    },
    statusEventNext: {
      color: colors.blue,
      fontWeight: 700,
    },
    statusLabelEventEnded: {
      color: colors.greenDark,
      fontWeight: 700,
    },
    statusEventEnded: {
      color: colors.greenDark,
      fontWeight: 700,
    },
    statusLabelEventRunning: {
      color: colors.pink,
      fontWeight: 700,
    },
    statusEventRunning: {
      color: colors.pinkLight,
    },
    boxEventCreateItens: {
      border: "1px solid " + colors.grayDLight,
      width: "100%",
      display: "flex",
      justifyContent: "space-around",
      padding: "35px",
      marginTop: 30,
    },
    cardItemAdd: {
      backgroundColor: colors.lilacMedium,
      boxShadow: palette.shadowSm,
      borderRadius: palette.radius,
      width: "16.133em",
      height: "12.234em",
      cursor: "pointer",
    },
    textCardItemAdd: {
      fontSize: "1.5rem !important",
      textAlign: "center",
    },
    iconCircleCardAdd: {
      borderRadius: "50%",
      backgroundColor: colors.lilacDarkMedium,
      width: 35,
      height: 35,
    },
    boxIconAdd: {
      padding: 10,
      display: "flex",
      justifyContent: "flex-end",
    },
    boxTextCardAdd: {
      padding: "20px",
    },
    boxEventLinks: {
      width: "100%",
      display: "flex",
      justifyContent: "start",
      marginTop: 30,
    },
    dividerCardLink: {
      borderColor: colors.grayDLight,
      width: 62,
    },
    containerCardLink: {
      width: 289,
      minHeight: 329,
      marginRight: 15,
      marginBottom: 15,
      padding: 15,
      cursor: "pointer !important",
      display: "flex",
      alignItems: "center",
    },
    titleCardLink: {
      color: colors.blueDark,
      marginTop: "10px !important",
      marginBottom: "15px !important",
    },
    eventOverviewBody: {
      fontFamily: fonts.interComponent,
    },
    eventStationListStudents: {
      backgroundColor: colors.white,
      border: "1px solid " + colors.grayDLight,
      borderRadius: palette.radius,
      boxShadow: "none",
      padding: "12px 16px",
      marginBottom: 12,
      alignItems: "center",
      justifyContent: "space-between",
    },
    eventStationTitle: {
      color: colors.purple,
      fontSize: "0.875rem !important",
      fontWeight: 600,
      marginRight: "4px !important",
    },
    eventStationSubTitle: {
      color: colors.blueDark,
      fontSize: "0.875rem !important",
      marginRight: "4px !important",
    },
    eventBoxskill: {
      marginTop: 40,
      width: "100%",
      backgroundColor: colors.white,
      display: "block",
    },
    boxTitleStation: {
      flexDirection: "row",
      display: "flex",
      justifyContent: "end",
      alignContent: "center",
    },
    appraiserName: {
      fontSize: "0.875rem !important",
      color: colors.purpleAvatarName,
    },
    textDetail: {
      color: colors.purpleDetail,
      fontSize: "0.875rem !important",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
    },
    boxContentAvatar: {
      flexDirection: "row",
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
    },
    titleStudent: {
      color: colors.blackMedium,
      fontSize: "0.875rem !important",
    },
    containerCardHomeLink: {
      width: "98%",
      minHeight: 329,
      marginRight: 15,
      marginBottom: 15,
      padding: 15,
      cursor: "pointer !important",
      display: "flex",
      alignItems: "center",
    },
    boxArea: {
      maxWidth: "937px !important",
      margin: "0 auto",
    },
    titleScenarioCheckbox: {
      fontSize: "1.7em !important",
      color: colors.blackDark,
      marginBottom: "20px !important",
    },
    boxInputVitalSigns: {
      paddingLeft: "70px",
      paddingRight: "70px",
      fontWeight: "bold",
      fontSize: "1.2em !important",
    },
    topField: {
      marginTop: "40px !important",
    },
    topBox: {
      marginTop: "20px !important",
    },
    divider: {
      borderColor: colors.grayDLight,
      width: "100% !important",
    },
    buttonStartSimulation: {
      color: colors.greenMedium,
      border: "1px solid " + colors.greenMedium,
    },
    alignButtonsListStation: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
    },
    containerStatus: {
      marginLeft: "80px",
      position: "relative",
      width: "92%",
      paddingBottom: 50,
      paddingTop: 50,
    },
    boxFiles: {
      backgroundColor: colors.purpleLightStation,
      marginTop: "20px",
      borderRadius: palette.radius,
      padding: "15px",
    },
    boxListFiles: {
      paddingBottom: "20px",
    },
    boxListFiles_1: {
      paddingBottom: "20px",
    },
  })
);
